export default __webpack_public_path__ + "static/media/Football.18ac8fe6.svg";